import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.WaiterMemory;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "WaiterMemory.Phaser.IntroductionScene.1",
            "WaiterMemory.Phaser.IntroductionScene.2",
            "WaiterMemory.Phaser.IntroductionScene.3",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/WaiterMemoryGame/scenes/GameIntro.ts